const TotalTokensBadge = ({
  isLoading,
  totalTokens,
  totalSessions,
}: {
  isLoading: boolean;
  totalTokens: number;
  totalSessions: number;
}) => (
  <div className="flex items-center gap-2">
    <div className="flex items-center gap-1.5 rounded-md bg-gray-100 px-2 py-1">
      {isLoading ? (
        <>
          <div className="h-2 w-2 animate-pulse rounded-full bg-gray-300" />
          <div className="h-3 w-16 animate-pulse rounded bg-gray-300" />
        </>
      ) : (
        <>
          <div className="h-2 w-2 rounded-full bg-blue-500" />
          <span className="text-xs font-medium leading-4 text-gray-600">
            <span className="tabular-nums">{totalTokens.toLocaleString()}</span>
            <span className="ml-1">tokens / </span>
            <span className="tabular-nums">{totalSessions.toLocaleString()}</span>
            <span className="ml-1">sessions</span>
          </span>
        </>
      )}
    </div>
  </div>
);

export default TotalTokensBadge;
